import React, { createContext } from 'react';
import SVG from 'react-inlinesvg';
import cx from 'classnames';



import MoreSvg from 'svg/icon-more-vert-new.svg';
import PlusSvg from 'svg/icon-plus-new.svg';
import MinusCircleSvg from 'svg/icon-minus-circle.svg';
import SlideshowSvg from 'svg/icon-slideshow-new-4.svg';
import DashboardSvg from 'svg/icon-dashboard.svg';
import ChatSvg from 'svg/icon-chat.svg';
import ArrowCapSvg from 'svg/icon-arrow-cap.svg';
import SettingsSvg from 'svg/icon-settings-new.svg';
import ImagesSvg from 'svg/icon-images.svg';
import AsteriskSvg from 'svg/icon-asterisk.svg';
import CheckmarkSvg from 'svg/icon-checkmark.svg';
import XMarkSvg from 'svg/icon-x-mark.svg';
import CopySvg from 'svg/icon-copy.svg';
import EditSvg from 'svg/icon-edit-new.svg';
import DeleteSvg from 'svg/icon-delete.svg';
import ExternalSvg from 'svg/icon-external.svg';
import DownloadSvg from 'svg/icon-download.svg';
import UploadSvg from 'svg/icon-upload.svg';
import GraphSvg from 'svg/icon-graph-3.svg';
import ExcelSvg from 'svg/icon-excel.svg';
import ChannelSvg from 'svg/icon-channel.svg';
import LinkSvg from 'svg/icon-link.svg';
import CodeSvg from 'svg/icon-code.svg';
import MoveSvg from 'svg/icon-move-item.svg';
import StreamSvg from 'svg/icon-stream.svg';
import SignalSvg from 'svg/icon-signal.svg';
import HealthSvg from 'svg/icon-health.svg';
import RefreshSvg from 'svg/icon-refresh.svg';
import TrashSvg from 'svg/icon-trash.svg';
import ImageSvg from 'svg/icon-image.svg';
import TagSvg from 'svg/icon-tag.svg';
import LogoutSvg from 'svg/icon-logout.svg';
import SaveSvg from 'svg/icon-save.svg';
import CalendarSvg from 'svg/icon-calendar.svg';
import PlaySvg from 'svg/icon-play.svg';
import PauseSvg from 'svg/icon-pause.svg';
import StopSvg from 'svg/icon-stop.svg';
import ChevronSvg from 'svg/icon-chevron.svg';
import TwitchSvg from 'svg/icon-twitch.svg';
import YouTubeSvg from 'svg/icon-youtube.svg';

import TwitchLogoSvg from 'svg/logo-twitch.svg';
import YouTubeLogoSvg from 'svg/logo-youtube.svg';
import HsLogoSvg from 'svg/logo-hs.svg';
import HsFaceLogoSvg from 'svg/logo-hs-face.svg';

const createSvg = (source, name) => ({ className, size = 'm', color, ...props }) => (
  <SVG {...props} className={cx("svg", name, size, color, className)} src={source} />
);

const Icon = ({ src, className, size = 'm', color, ...props }) => (
  <SVG {...props} className={cx("g-icon", size, color, className)} src={src} />
);

const createIcon = (src, name) => ({ className, ...props }) => <Icon {...props} src={src} className={cx(name, className)} />;

export const TwitchLogo = createSvg(TwitchLogoSvg, 'twitch');
export const YouTubeLogo = createSvg(YouTubeLogoSvg, 'youtube');
export const HappyLogo = createSvg(HsLogoSvg, 'happy');
export const HappyFaceLogo = createSvg(HsFaceLogoSvg, 'happy-face');

export const ArrowCap = createSvg(ArrowCapSvg, 'arrow-cap');

export const MoreIcon = createIcon(MoreSvg, 'more');
export const TagIcon = createIcon(TagSvg, 'tag');
export const ChatIcon = createIcon(ChatSvg, 'chat');
export const DashboardIcon = createIcon(DashboardSvg, 'dashboard');
export const ExternalIcon = createIcon(ExternalSvg, 'chat');
export const SlideshowIcon = createIcon(SlideshowSvg, 'slideshow');
export const SettingsIcon = createIcon(SettingsSvg, 'settings');
export const ImagesIcon = createIcon(ImagesSvg, 'images');
export const AsteriskIcon = createIcon(AsteriskSvg, 'asterisk');
export const PlusIcon = createIcon(PlusSvg, 'plus');
export const MinusCircleIcon = createIcon(MinusCircleSvg, 'minus-circle');
export const CheckmarkIcon = createIcon(CheckmarkSvg, 'checkmark');
export const ChannelIcon = createIcon(ChannelSvg, 'channel');
export const XMarkIcon = createIcon(XMarkSvg, 'x-mark');
export const CopyIcon = createIcon(CopySvg, 'copy');
export const EditIcon = createIcon(EditSvg, 'edit');
export const DeleteIcon = createIcon(TrashSvg, 'delete');
export const UploadIcon = createIcon(UploadSvg, 'upload');
export const RefreshIcon = createIcon(RefreshSvg, 'refresh');
export const DownloadIcon = createIcon(DownloadSvg, 'download');
export const GraphIcon = createIcon(GraphSvg, 'graph');
export const ExcelIcon = createIcon(ExcelSvg, 'excel');
export const LinkIcon = createIcon(LinkSvg, 'link');
export const CodeIcon = createIcon(CodeSvg, 'code');
export const StreamIcon = createIcon(StreamSvg, 'stream');
export const SignalIcon = createIcon(SignalSvg, 'signal');
export const SaveIcon = createIcon(SaveSvg, 'save');
export const ImageIcon = createIcon(ImageSvg, 'image');
export const HealthIcon = createIcon(HealthSvg, 'health');
export const LogoutIcon = createIcon(LogoutSvg, 'logout');
export const CalendarIcon = createIcon(CalendarSvg, 'calendar');
export const PlayIcon = createIcon(PlaySvg, 'play');
export const PauseIcon = createIcon(PauseSvg, 'pause');
export const StopIcon = createIcon(StopSvg, 'stop');
export const MoveIcon = createIcon(MoveSvg, 'move');
export const TwitchIcon = createIcon(TwitchSvg, 'twitch');
export const YouTubeIcon = createIcon(YouTubeSvg, 'youtube');
export const DownChevronIcon = createIcon(ChevronSvg, 'chevron rotate-c');
export const UpChevronIcon = createIcon(ChevronSvg, 'chevron rotate-cc');
export const RightChevronIcon = createIcon(ChevronSvg, 'chevron');
export const LeftChevronIcon = createIcon(ChevronSvg, 'chevron rotate-180');
export const BackIcon = createIcon(ChevronSvg, 'chevron rotate-180');
